"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusToTheme = void 0;
var _reliability = require("../../../types/reliability");
var _ui = require("../../../types/ui");
const statusToTheme = status => {
  const themes = {
    [_reliability.EReliabilityStatus.Problem]: _ui.EReliabilityTheme.Red,
    [_reliability.EReliabilityStatus.Reliable]: _ui.EReliabilityTheme.Green
  };
  return themes[status];
};
exports.statusToTheme = statusToTheme;